<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <div class="container">
    <div class="carousel">
      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let player of lastPlayers">
          <img [src]="player" />
        </div>
      </div>
      <div class="carousel-indicators">
        <span
          *ngFor="let dot of getIndicators(); let i = index"
          [class.active]="i === currentSlide"
          (click)="goToSlide(i)"
        ></span>
      </div>
    </div>
  </div>
</nb-card>
